import styled from 'styled-components'

export const P = styled.div`
  color: ${props => props.theme};
`



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/styles/LargeScreenRefreshButton.js